import { SPayIcon } from '@components/Icon';
import { AboutProps } from './About.type';
import { Benefit } from '..';

const About = ({
  title,
  description,
  benefitTitle,
  benefitChildren,
}: AboutProps) => (
  <div className="about-container">
    <div className="spay-logo">
      <SPayIcon />
    </div>

    <div className="about-content">
      <h1>{title}</h1>
      <span>{description}</span>
    </div>

    <Benefit benefitTitle={benefitTitle} benefitChildren={benefitChildren} />
  </div>
);

export default About;
